/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Moderationqueuedescription2Inputs */

const en_moderationqueuedescription2 = /** @type {(inputs: Moderationqueuedescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reported messages and users awaiting review`)
};

const de_moderationqueuedescription2 = /** @type {(inputs: Moderationqueuedescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gemeldete Nachrichten und Nutzer, die auf Prüfung warten`)
};

/**
* | output |
* | --- |
* | "Reported messages and users awaiting review" |
*
* @param {Moderationqueuedescription2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const moderationqueuedescription2 = /** @type {((inputs?: Moderationqueuedescription2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Moderationqueuedescription2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_moderationqueuedescription2(inputs)
	return de_moderationqueuedescription2(inputs)
});
export { moderationqueuedescription2 as "moderationQueueDescription" }